import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../Ihouse/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../Ihouse/layout/core'
import {MasterInit} from '../Ihouse/layout/MasterInit'
import {AuthInit} from './modules/auth'
import {ThemeModeProvider} from '../Ihouse/partials'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <ThemeModeProvider>
            <AuthInit>
              <Outlet />
              <MasterInit />
            </AuthInit>
          </ThemeModeProvider>
        </LayoutProvider>
        <ToastContainer autoClose={5000} />
      </I18nProvider>
    </Suspense>
  )
}

export {App}
